export default "__VITE_ASSET__Bj_13Uvl__"